/**
 * helixaction.js
 **/

import * as types from '../actiontypes';
import env from '../../util/env';
import {API_RESOURCES, createApiReadAction} from '../../util/api';

export function getProjectsByProjectIdFromHelixApp(data) {
	const serviceUrl =
		env.getBaseURL('Helix_Platform_Base_Url') + '/api/services/app/CanvasIntegration/GetProjectsByProjectIds';
	return {
		type: types.GET_PROJECTDETAIL_BY_PROJECTID_FROM_HELIX,
		meta: {
			api: {
				url: serviceUrl,
				method: 'POST',
				headers: {CallerApp: 'can'},
				data: data
			},
			payload: data
		}
	};
}

export function getProjectFilterMetaDataByProjectIdFromHelixApp(projectId, helixAnalyzerId) {
	const serviceUrl =
		env.getBaseURL('Helix_Analyzer_Base_Url') +
		'analyzer/api/data/' +
		projectId +
		'/' +
		helixAnalyzerId +
		'/filtermetadata';

	return {
		type: types.GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX,
		meta: {
			api: {
				url: serviceUrl,
				method: 'POST'
			}
		}
	};
}

export const cleanUpHelixProjectState = () => {
	return {
		type: types.CLEANUP_HELIX_PROJECT_STATE
	};
};

export const getHelixProject = (engagementId) =>
	createApiReadAction(types.GET_HELIX_PROJECT, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.HELIX_PROJECTS]: null
	});
